(function () {
  if (window.__twrdChooseSize) return;
  window.__twrdChooseSize = true;

  function sizeFieldset() {
    var sets = document.querySelectorAll('.product-single variant-radios fieldset.product-form__swatch, .product-single__box fieldset.product-form__swatch');
    for (var i = 0; i < sets.length; i++) {
      var input = sets[i].querySelector('input[type="radio"]');
      if (input && /^(size|størrelse|storrelse)$/i.test(String(input.name || '').trim())) return sets[i];
    }
    return null;
  }

  /* Everything is looked up live and delegated from document, because the theme
     re-renders the picker whenever Style or Color changes. */
  function isSizeTarget(t) {
    if (!t || !t.closest) return false;
    var hit = t.closest('label, input[type="radio"]');
    if (!hit) return false;
    var fs = hit.closest('fieldset');
    return !!(fs && fs === sizeFieldset());
  }

  function initChooseSize() {
    var fs = sizeFieldset();
    if (!fs) return;
    if (/[?&]variant=/.test(window.location.search)) return;
    if (fs.querySelectorAll('input[type="radio"]').length < 2) return;

    var body = document.body;
    body.classList.add('twrd-size-unchosen');

    function chosen() { body.classList.remove('twrd-size-unchosen'); }
    function nudge() {
      var f = sizeFieldset();
      if (!f) return;
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      f.classList.add('twrd-size-nudge');
      setTimeout(function () { f.classList.remove('twrd-size-nudge'); }, 1400);
      var first = f.querySelector('input[type="radio"]');
      if (first) { try { first.focus({ preventScroll: true }); } catch (_) {} }
    }

    document.addEventListener('click', function (e) {
      if (isSizeTarget(e.target)) chosen();
      if (e.target.closest && e.target.closest('.twrd-sticky [data-twrd-size-btn]')) chosen();
    }, true);
    document.addEventListener('change', function (e) {
      if (e.target && /^(size|størrelse|storrelse)$/i.test(String(e.target.name || ''))) chosen();
    }, true);

    function guard(e) {
      if (!body.classList.contains('twrd-size-unchosen')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      nudge();
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      /* The Pair adds the tee in the size chosen above, so it waits for a size too. */
      if (e.target.closest('.product-form__add-btn, [data-twrd-sticky-add], [data-twrd-bundle-add]')) guard(e);
    }, true);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('.product-single form[action*="/cart/add"]') && !form.closest('.twrd-bundle')) guard(e);
    }, true);
  }

  function hasVisibleContent(el) {
    var nodes = el.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.tagName === 'STYLE' || n.tagName === 'SCRIPT') continue;
      var r = n.getBoundingClientRect();
      if (r.width < 1 || r.height < 1) continue;
      var cs = getComputedStyle(n);
      if (cs.visibility === 'hidden' || cs.opacity === '0') continue;
      if (n.tagName === 'svg' || n.tagName === 'IMG') return true;
      for (var j = 0; j < n.childNodes.length; j++) {
        var c = n.childNodes[j];
        if (c.nodeType === 3 && c.textContent.trim() && !/^\s*0\s+reviews?\s*$/i.test(c.textContent)) return true;
      }
    }
    return false;
  }
  function checkEmptyApps() {
    document.querySelectorAll('.product-single__box > .product-single__box__block').forEach(function (b) {
      if (!/@app/.test(b.className)) return;
      b.classList.remove('twrd-empty-app');
      if (!hasVisibleContent(b)) b.classList.add('twrd-empty-app');
    });
  }

  function moveAskLink() {
    if (document.querySelector('.twrd-ask-link--moved')) return;
    var ask = document.querySelector('.product-single variant-radios .twrd-ask-link');
    var add = document.querySelector('.product-single .product-form .product-form__add');
    if (!ask || !add) return;
    ask.classList.add('twrd-ask-link--moved');
    add.insertAdjacentElement('afterend', ask);
  }

  function run() {
    initChooseSize();
    moveAskLink();
    checkEmptyApps();
    setTimeout(checkEmptyApps, 1500);
    setTimeout(checkEmptyApps, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
